<template>
  <div class="header">
    <div class="content">
      <a href="/">
        <img class="pointer" src="~@/assets/img/main/logo.svg" alt="logo" />
      </a>
      <div class="title">
        <img src="~@/assets/img/contentInfo/contentInfo.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goInquiry () {
      this.$router.push({ name: 'selectionCategoryList' })
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  min-width: calc(100vw - 56px);
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  border-bottom: 1px solid #f5f6fa;

  .content {
    display: flex;
    align-items: center;
    width: 1200px;
  }

  .title {
    width: 141px;
    margin-left: 41px;

    img {
      width: 100%;
    }
  }
}
</style>
